import { axiosInstance } from "./axios";

interface SortParams {
  field: string;
  order: "asc" | "desc";
}

export const getTransactionHistory = async (
  teamId: string,
  sortField?: string,
  sortOrder?: string
) => {
  try {
    let url = `/billing/transactions?teamId=${teamId}`;
    if (sortField && sortOrder) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder}`;
    }
    return await axiosInstance.get(url);
  } catch (error) {
    throw error;
  }
};

export const getPaymentHistory = async (
  teamId: string,
  sortField?: string,
  sortOrder?: string
) => {
  try {
    let url = `/billing/payment/history?teamId=${teamId}`;
    if (sortField && sortOrder) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder}`;
    }
    return await axiosInstance.get(url);
  } catch (error) {
    throw error;
  }
};

export const addCredit = async (data: {
  amount: number;
  teamId: string;
  paymentMethod?: string;
  successUrl?: string;
  cancelUrl?: string;
}) => {
  try {
    return await axiosInstance.post("/billing/add-credit", data);
  } catch (error) {
    throw error;
  }
};

export const getTeamCredits = async (teamId: string) => {
  try {
    return await axiosInstance.get(`/billing/credits?teamId=${teamId}`);
  } catch (error) {
    throw error;
  }
};

// Stripe-specific functions
export const createStripeCheckoutSession = async (
  teamId: string,
  amount: number,
  successUrl: string,
  cancelUrl: string
) => {
  try {
    return await axiosInstance.post("/billing/add-credit", {
      teamId,
      amount,
      paymentMethod: "stripe",
      successUrl,
      cancelUrl,
    });
  } catch (error) {
    throw error;
  }
};

export const processStripePayment = async (sessionId: string) => {
  try {
    return await axiosInstance.get(`/billing/payment/success/${sessionId}`);
  } catch (error) {
    throw error;
  }
};

export const addTeamCreditBySuperAdmin = async (data: {
  teamId: string;
  amount: number;
  description: string;
}) => {
  try {
    return await axiosInstance.post(
      `/billing/super-admin/add-team-credit`,
      data
    );
  } catch (error) {
    throw error;
  }
};
